<template>
<div>
  <div slot="modal-title" class="text-center">
    <h3>{{title}} <code class="text-nowrap">{{' [' +
      (inspections && sinspection != null && inspections[sinspection] &&
      inspections[sinspection].value.landslide && inspections[sinspection].value.landslide.inspection_date
      ? inspections[sinspection].value.landslide.inspection_date : '-') + ']'}} </code> </h3>
  </div>
  <div class="container">
    <b-row>
      <b-col>
        <div class="card">
          <div class="card-header no-border">
            <div class="d-flex justify-content-between">
              <h3 class="card-title">IFRM</h3>
            </div>
          </div>
          <div class="card-body" style="padding-right: 80px">
            <div class="position-relative">
              <!--<canvas id="visitors-chart" height="200"></canvas>-->
              <bar-chart v-if="loaded" :chart-data="chartdata" :options="chartoptions" :height="200" :plugins="chartplugins"></bar-chart>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="7">
        <div class="card">
            <div class="card-header no-border">
              <h3 class="card-title">Evaluación Cualitativa</h3>
            </div>
            <div class="card-body p-0">
              <b-table hover striped :items="table" :fields="fields" small>
                <template slot="value" slot-scope="data">
                  <div class="text-nowrap">
                    {{data.item[4]}}
                    <small :class="'mr-1 ' + (data.item[4] < data.item[5] ?
                      'text-success' : (data.item[4] > data.item[5] ? 'text-danger' : 'text-warning'))">

                      <fa-icon :icon="(data.item[4] < data.item[5] ?
                      'arrow-down' : (data.item[4] > data.item[5] ? 'arrow-up' : 'dot-circle'))" />
                      <!--{{ Math.round(100 - 100 * data.item[4] / data.item[5]) || 0}}% -->
                    </small>
                  </div>
                </template>
              </b-table>
            </div>
        </div>

        <div class="card" v-if="(inspections && sinspection !== null && inspections[sinspection])">
            <div class="card-header no-border">
              <h3 class="card-title">Observaciones</h3>
            </div>
            <div class="card-body" style="text-align: justify;">
              <div class="d-flex justify-content-between align-items-center border-bottom mb-3">
                <p class="d-flex flex-column">
                  <span class="font-weight-bold">
                    Descripción
                  </span>
                  <span>{{inspections[sinspection].value.description}}</span>
                </p>
              </div>
              <div class="d-flex justify-content-between align-items-center border-bottom mb-3">
                <p class="d-flex flex-column">
                  <span class="font-weight-bold">
                    Medida de Acción
                  </span>
                  <span>{{inspections[sinspection].value.action_measure}}</span>
                </p>
              </div>

              <div class="d-flex justify-content-between align-items-center border-bottom mb-3" v-if="(inspections && sinspection !== null && inspections[sinspection].value.obs_ot)">
                <p class="d-flex flex-column">
                  <span class="font-weight-bold">
                    Oficina Técnica
                  </span>
                  <span>{{inspections[sinspection].value.obs_ot}}</span>
                </p>
              </div>

              <div class="d-flex justify-content-between align-items-center">
                <p class="d-flex flex-column">
                  <span class="font-weight-bold">
                    Supervisor CE INMAC
                  </span>
                  <span>{{inspections[sinspection].value.username}}</span>
                </p>
                <p class="d-flex flex-column" v-if="(inspections[sinspection].value.supervisor_2)">
                  <span class="font-weight-bold">
                    Jefe de Obra INMAC
                  </span>
                  <span>{{inspections[sinspection].value.supervisor_2}}</span>
                </p>
                <p class="d-flex flex-column" v-if="(inspections[sinspection].value.supervisor_3)">
                  <span class="font-weight-bold">
                    Supervisión de OT/Gerencia
                  </span>
                  <span>{{inspections[sinspection].value.supervisor_3}}</span>
                </p>
              </div>
              <router-link class="btn btn-info no-print"
                :to="{ name: $route.params.json + '_view', params: { typex: $route.params.typex, json: $route.params.json, id: inspections[sinspection].value._id } }"
                target="_blank" >
                Mayor detalle
              </router-link>
            </div>
        </div>
      </b-col>
      <b-col md="5">
        <div ref="parentImagenes">
          <div ref="imagenes" class="card" v-if="loadedFiles">
            <div class="card-header no-border">
              <div class="d-flex justify-content-between">
                <h3 class="card-title">Imágenes</h3>
              </div>
            </div>
            <div class="flex-container" style="center">
                <div style="flex-grow: 1">
                </div>
                <div style="flex-grow: 1">

                    <div v-for="(elem, key, i) in inspections[sinspection].value.image" v-bind:key="'img_'+i" :id="'img'+i">
                      <b-img thumbnail fluid style="max-width:380px" class="img-fluid" :src="loadedFiles[key]" alt="Ninguno" :title="key"/>
                    </div>

                    <div v-for="(elem, key, i) in inspections[sinspection].value.esquema" v-bind:key="'schema_'+i" :id="'schema'+i">
                      <b-img thumbnail fluid style="max-width:380px" class="img-fluid" :src="loadedFiles[key]" alt="Ninguno" :title="key"/>
                    </div>

                </div>
                <div style="flex-grow: 1">
                </div>
            </div>
          </div>
          <!-- /.card -->
        </div>
      </b-col>
    </b-row>
  </div>
</div>
</template>
<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import AttachmentsLoader from '../auxx/AttachmentsLoader'
import BarChart from '../chart/BarChart.vue'

export default {
  components: {
    BarChart
  },
  data () {
    return {
      imageFullscreen: false,
      title: '',
      inspections: [],
      sinspection: null,
      attachmentsLoader: null,
      table: [],
      fields: [
        {
          key: '0',
          label: 'Variable'
        },
        {
          key: '1',
          label: 'Evaluación'
        },
        {
          key: 'value',
          label: 'Valor'
        }
      ],
      chartdata: {
        labels: [10, 10],
        datasets: [
          {
            label: 'data',
            backgroundColor: '#f87979',
            data: [10, 10]
          }
        ]
      },
      chartoptions: {
        animation: {
          duration: 0
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              ticks: {
                userCallback: function (label, index, labels) {
                  var date = new Date(label)
                  // return '  ' + months[date.getMonth()] + ' ' + date.getFullYear().toString().substr(-2)
                  return '   ' + (date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear().toString().substr(-2)) + '   '
                },
                callback (value, index) {
                  var months = [' ', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Set',
                    'Oct', 'Nov', 'Dic']
                  if (value.length === 9) {
                    return '  ' + months[parseInt(value.toString().substr(0, 2))] + ' ' + value.toString().substr(-4)
                  } else {
                    return ' '
                  }
                }
              },
              type: 'time',
              time: {
                unit: 'month',
                displayFormats: {
                  month: 'MM - YYYY'
                }
              }
            }
          ],
          yAxes: [{
            type: 'linear',
            ticks: {
              beginAtZero: true,
              suggestedMax: 60
            },
            afterBuildTicks: function (chartObj) {
              chartObj.ticks = [0, 10, 20, 32, 42, 50]
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var date = new Date(tooltipItem.xLabel)
              var label = (date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear()) +
                ': IFRM ' + Math.round(tooltipItem.yLabel * 100) / 100
              return label
            }
          }
        },
        onClick: this.chartClick
      },
      chartplugins: [
        {
          id: 'test1',
          beforeDraw: function (chart, easing) {
            var ctx = chart.ctx
            var chartArea = chart.chartArea
            var prevy = chartArea.bottom
            ctx.save()
            for (var i = 1; i < 6; i++) {
              // console.log(chart)
              var datax = chart.getDatasetMeta(i).data
              // console.log(model)
              ctx.fillStyle = datax[0]._model.backgroundColor
              ctx.fillRect(datax[0]._model.x, datax[0]._model.y, datax[1]._model.x - datax[0]._model.x, prevy - datax[0]._model.y)
              prevy = datax[0]._model.y
            }
            ctx.restore()
          }
        }
      ],
      metadata: null,
      inspection: null,
      loaded: false,
      ticks: [
        { y: 10, r: 0, g: 176, b: 80, nombre: 'Muy Bajo' },
        { y: 20, r: 146, g: 208, b: 80, nombre: 'Bajo' },
        { y: 32, r: 255, g: 255, b: 0, nombre: 'Moderado' },
        { y: 42, r: 255, g: 120, b: 0, nombre: 'Moderadamente Alto' },
        { y: 50, r: 255, g: 0, b: 0, nombre: 'Alto' }
      ]
    }
  },
  computed: {
    loadedFiles () {
      if (this.attachmentsLoader) {
        return this.attachmentsLoader.loadedFiles
      }
      return null
    }
  },
  watch: {
    /* inspection (to, from) {d
      this.loadInspections()
    }, */
    sinspection (to, from) {
      if (to !== null) {
        var obj = this
        this.loadPlot()
        this.loadTable()
        this.loadAttachments()
        var insp = obj.inspections[obj.sinspection].value
        if (insp.identification) {
          if (insp.identification.type && insp.identification.type === 'plataforma') {
            var titulo = ''
            var parcial = ''
            for (var i in obj.metadata.identification.choices[1].children.platform.choices) {
              parcial = obj.metadata.identification.choices[1].children.platform.choices[i]
              if (insp.identification.platform === parcial.value) {
                titulo = titulo + parcial.display_name
              }
            }
            for (i in obj.metadata.identification.choices[1].children.instalation.choices) {
              parcial = obj.metadata.identification.choices[1].children.instalation.choices[i]
              if (insp.identification.instalation === parcial.value) {
                titulo = titulo + ' - ' + parcial.display_name
              }
            }
            for (i in obj.metadata.identification.choices[1].children.talud.choices) {
              parcial = obj.metadata.identification.choices[1].children.talud.choices[i]
              if (insp.identification.talud === parcial.value) {
                titulo = titulo + ' - ' + parcial.display_name
              }
            }
            obj.title = titulo
          } else {
            for (i in obj.metadata.identification.choices[0].children.flowline.choices) {
              var j = obj.metadata.identification.choices[0].children.flowline.choices[i]
              if (j.value === insp.identification.flowline) {
                if (parseInt(insp.identification.progressive % 1000) > 99) {
                  if (parseInt(insp.identification.progressive / 1000) > 9) {
                    obj.title = j.display_name + ' PK' +
                    parseInt(insp.identification.progressive / 1000) + '+' + parseInt(insp.identification.progressive % 1000)
                  } else {
                    obj.title = j.display_name + ' PK' +
                    '0' + parseInt(insp.identification.progressive / 1000) + '+' + parseInt(insp.identification.progressive % 1000)
                  }
                } else if (parseInt(insp.identification.progressive % 1000) > 9) {
                  if (parseInt(insp.identification.progressive / 1000) > 9) {
                    obj.title = j.display_name + ' PK' +
                    parseInt(insp.identification.progressive / 1000) + '+0' + parseInt(insp.identification.progressive % 1000)
                  } else {
                    obj.title = j.display_name + ' PK' +
                    '0' + parseInt(insp.identification.progressive / 1000) + '+0' + parseInt(insp.identification.progressive % 1000)
                  }
                } else {
                  if (parseInt(insp.identification.progressive / 1000) > 9) {
                    obj.title = j.display_name + ' PK' +
                    parseInt(insp.identification.progressive / 1000) + '+00' + parseInt(insp.identification.progressive % 1000)
                  } else {
                    obj.title = j.display_name + ' PK' +
                    '0' + parseInt(insp.identification.progressive / 1000) + '+00' + parseInt(insp.identification.progressive % 1000)
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  mounted () {
    var obj = this
    // console.log(obj.$route)
    // this.inspection = obj.$route.params.inspection

    import('../../configuration/json/inspection.json').then(function (met) {
      obj.metadata = met
      obj.get_db().then(function (db) {
        // console.log(obj.$route.params.id)
        db.get(obj.$route.params.id).then(function (insp) {
          obj.inspection = insp
          obj.loadInspections()
        })
      })
      // console.log(obj.inspection)
    })
  },
  methods: {
    ...mapActions([
      'get_db'
    ]),
    loadInspections () {
      let obj = this
      if (this.inspection) {
        obj.get_db().then(function (db) {
          var query = {}
          if (obj.inspection.identification.type && obj.inspection.identification.type === 'plataforma') {
            query = {
              startkey: [obj.inspection.identification.platform, obj.inspection.identification.instalation,
                obj.inspection.identification.talud],
              endkey: [obj.inspection.identification.platform, obj.inspection.identification.instalation,
                obj.inspection.identification.talud, {}],
              descending: false
            }
          } else {
            query = {
              startkey: [obj.inspection.identification.flowline, obj.inspection.identification.progressive,
                obj.inspection.identification.side_to_ddv],
              endkey: [obj.inspection.identification.flowline, obj.inspection.identification.progressive,
                obj.inspection.identification.side_to_ddv, {}],
              descending: false
            }
          }
          db.query('app/checklist', query).then(function (res) {
            obj.$set(obj, 'inspections', res.rows)
            for (var i in res.rows) {
              if (res.rows[i].value._id === obj.inspection._id) {
                obj.$set(obj, 'sinspection', parseInt(i))
              }
            }
            /* obj.loadPlot()
            obj.loadTable() */
          })
        })
        // obj.$refs['modal'].show()
      } else {
        obj.title = ''
        obj.inspections = []
        obj.sinspection = null
        obj.attachments = []
        obj.table = []
        obj.imageFullscreen = false
      }
    },
    loadTable () {
      var obj = this
      obj.$set(obj, 'table', [])
      for (var i in obj.inspections[obj.sinspection].value.ifrm.ifrm_table) {
        var item = obj.inspections[obj.sinspection].value.ifrm.ifrm_table[i]
        if (obj.sinspection > 0) {
          item.push(obj.inspections[obj.sinspection - 1].value.ifrm.ifrm_table[i][4])
        } else {
          item.push(item[4])
        }
        obj.table.push(item)
      }
    },
    loadPlot () {
      var obj = this
      var data = []
      var colors = []
      var borders = []
      for (var i in obj.inspections) {
        var insp = obj.inspections[i].value
        var elem = {
          x: new Date(insp.landslide && insp.landslide.inspection_date ? insp.landslide.inspection_date : '2000-01-01'),
          y: (insp.ifrm && insp.ifrm.ifrm_value ? (parseFloat(insp.ifrm.ifrm_value) || 0) : 0)
        }
        elem.x = new Date(elem.x.getTime() + elem.x.getTimezoneOffset() * 60000)
        data.push(elem)
        var ifrm = data[data.length - 1].y
        var color = null
        if (ifrm <= 10) {
          color = 'rgb(0,176,80)'
        } else if (ifrm <= 20) {
          color = 'rgb(146,208,80)'
        } else if (ifrm <= 32) {
          color = 'rgb(255,255,0)'
        } else if (ifrm <= 42) {
          color = 'rgb(255,192,0)'
        } else {
          color = 'rgb(255,0,0)'
        }
        colors.push(color)
        if (parseInt(i) === obj.sinspection) {
          borders.push('black')
        } else {
          borders.push('rgb(120,120,120)')
        }
      }
      var d1 = data[0].x
      var d2 = data[data.length - 1].x
      if (d1 === d2) { d2 = new Date(d1.valueOf() + 1 * 24 * 60 * 60) }
      var ticks = []
      for (i in obj.ticks) {
        ticks[i] = {
          type: 'line',
          label: obj.ticks[i].nombre,
          data: [
            { x: 1.05 * d1 - 0.05 * d2, y: obj.ticks[i].y },
            { x: 1.05 * d2 - 0.05 * d1, y: obj.ticks[i].y }
          ],
          backgroundColor: 'rgba(' + obj.ticks[i].r + ',' + obj.ticks[i].g + ',' + obj.ticks[i].b + ',0.25)',
          borderColor: 'rgb(' + obj.ticks[i].r + ',' + obj.ticks[i].g + ',' + obj.ticks[i].b + ')',
          borderWidth: 1,
          fill: false
        }
      }
      this.$set(this, 'chartdata', {
        datasets: [
          {
            type: 'scatter',
            label: 'IFRM',
            fill: false,
            showLine: true,
            pointRadius: 8,
            pointHoverRadius: 10,
            pointBackgroundColor: colors,
            // pointBackgroundColor: 'rgb(150,150,255)',
            pointBorderColor: borders,
            borderWidth: 2,
            borderColor: 'rgb(120,120,120)',
            data: data
          },
          ...ticks
        ]
      })
      obj.loaded = true
    },
    loadAttachments () {
      let obj = this
      /* var obj = this
      obj.attachments = []
      var p = Promise.resolve(0)
      if (obj.inspections && obj.sinspection !== null && obj.inspections[obj.sinspection]) {
        obj.get_db().then(function (db) {
          var indexes = []
          for (var i in (obj.inspections[obj.sinspection].value.image || {})) {
            indexes.push(i)
          }
          for (i in (obj.inspections[obj.sinspection].value.esquema || {})) {
            indexes.push(i)
          }
          for (i in indexes) {
            p = p.then(function (i) {
              return db.getAttachment(obj.inspections[obj.sinspection].value._id, indexes[i], {attachments: true, binary: true})
              .then(function (img) {
                obj.attachments.push(window.URL.createObjectURL(img))
              }).catch(function (err) {
                console.log(err)
              })
            }(i))
          }
        })
      } */
      var insp = obj.inspections[obj.sinspection].value
      let AttachmentsLoaderClass = Vue.extend(AttachmentsLoader)
      obj.attachmentsLoader = new AttachmentsLoaderClass({
        router: obj.$router,
        store: obj.$store,
        propsData: {
          idx_image: insp._id,
          idx_esquema: insp._id,
          vattachments_image: insp.image,
          vattachments_esquema: insp.esquema
        }
      })
      obj.attachmentsLoader.$mount()
    },
    chartClick (event, array) {
      if (array && array.length) {
        this.$set(this, 'sinspection', parseInt(array[0]._index))
        /* this.loadPlot()
        this.loadTable() */
      }
    }
  }
}
</script>
<style>
@media print {
  .no-print, .no-print * {
    display: none !important;
  }
}
@media (min-width: 768px) {
  .modal-lg {
    width: 90% !important;
   max-width:1200px !important;
  }
}
#sidebar-overlay {
  z-index: 1037 !important;
}
.main-sidebar {
  z-index: 1038 !important;
}
.leaflet-pseudo-fullscreen {
  z-index: 1039 !important;
}
li{
  margin: 0px;
  padding: 0px;
}
ul{
  margin: 0px;
  padding: 0px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;

}

th, td {
  text-align: left;
  padding-left: 6px;
  padding-right: 6px;
}

.flex-container {
  display: flex;
  justify-content: stretch;

}

.flex-container > div {
  width: auto;
  margin: 0px;
  text-align: center;
  line-height: 35px;
  font-size: 14px;

  justify-content: center;

}
.invoice-logo {
  height: 50px;
  width: auto;
}

tr:nth-child(even){background-color: #fff}

.print-container {
    max-width: 1250px;
    margin: 5px auto;
    background: white;
    padding: 2px 30px;

  }
  .print-container .header {
    margin-bottom: 0px;
    border-bottom: 0px solid #dbdbdb;
    padding-bottom: 0px;
  }
  .print-container table {
    margin-top: 0px;
  }
  .print-container table tbody tr.no-border:first-child {
    opacity: 0.6 !important;
  }
  .print-container .summary-table {
    border: 1px solid #DDE1E4;
  }
  .print-container .summary-table tr td:last-child {
    text-align: right;
  }
  .print-container .summary-table tr th:last-child {
    text-align: right;
  }
  .print-container .summary-table td {
    border-left: 1px solid #dbdbdb;
  }
  .print-container .summary-table th {
    border-left: 1px solid #dbdbdb;
  }
  .print-container .summary-table thead {
    color: #737F8B;
    text-transform: uppercase;
  }
  .print-container .ft-18 {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .print-container .adder {
    font-size: 16px;
    font-weight: 500;
    text-align: right;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
  }
  .print-container .total {
    font-size: 22px;
  }
  .print-container .mega {
    font-size: 33px;
    margin-bottom: 10px;
  }
  .row {
    margin-left: 0.0px;
  }
  .card-header{
    font-weight: bold;
  }
  @media print {
    h1, h2, h3, h4, h5, h6 {
      font-weight: bold;
    }
    h1:first-letter, h2:first-letter, h3:first-letter, h4:first-letter, h5:first-letter, h6:first-letter {
      font-size: inherit;
    }
  }
</style>
